import { render, staticRenderFns } from "./index.vue?vue&type=template&id=116eb7f3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116eb7f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116eb7f3')) {
      api.createRecord('116eb7f3', component.options)
    } else {
      api.reload('116eb7f3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=116eb7f3&scoped=true", function () {
      api.rerender('116eb7f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/examineClass/index.vue"
export default component.exports